import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AccountService, AlertService } from '@app/_services';
import { EmailVerificationService } from '@app/_services/email-verification.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: 'forgot-password.component.html',
  styleUrls: ['./login.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  errorMessage: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private emailService: EmailVerificationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.alertService.clear();
    const email = this.form.get('email').value;

    this.emailService.checkEmail(email).subscribe({
      next: (res) => {
        if (res.checkFlg) {
          this.emailService.sendResetPasswordEmail(email).subscribe({
            next: () => {
              this.router.navigate(['account/login']);
              this.alertService.success(
                'A reset password link has been sent to your email.'
              );
            },
            error: () => {
              this.errorMessage =
                'Failed to send reset password email. Please try again later.';
              this.loading = false;
            },
          });
        } else {
          this.errorMessage = 'This email does not exist in our system.';
          this.loading = false;
        }
      },
      error: () => {
        this.errorMessage = 'An error occurred while checking the email.';
        this.loading = false;
      },
    });
  }
}
